/**
 * Randomize the array elements and returns it in a new array
 *
 * randomArray([1,"hey",{universe: 42}]) -> "["hey",{universe: 42}, 1]
 *
 * @param  { Array } array
 * @returns Array
 *
 * Total big O is => O(n)
 */

export function randomArray(array) {
  let randomArray = [];

  while (array.length !== 0) {
    let randomIndex = Math.floor(Math.random() * array.length);
    randomArray.push(array[randomIndex]);
    array.splice(randomIndex, 1); 
  }

  return randomArray;
}

/**
 * Gets the difference between two arrays
 *
 *  diffArray([1, 2, 3], [1, 2]) -> [ 3 ]
 *
 * @param  { Array } array1
 * @param  { Array } array2
 * @returns Array
 *
 */
export function diffArray(array1, array2) {
  return array1.filter(i => array2.indexOf(i) < 0);
}



// WEBPACK FOOTER //
// ./src/newDropshipperApp/utils/array.js